import { useDispatch } from "react-redux";
import { fetchLoggedInUserDetails } from "ducks/actions";
import isEmpty from "lodash/isEmpty";
import { paths } from "utils/constants";
import {
  gotoUrl,
  pathWithChannel,
  isWebView,
  loggedInUserDetailsAPIParams,
  updateTokenToApp
} from "utils/helpers";
import useFetchOrdersAndRedirect from "./useFetchOrdersAndRedirect";

const useAuthorizedUserRedirection = redirectChannel => {
  const dispatch = useDispatch();
  const fetchOrdersAndRedirect = useFetchOrdersAndRedirect(redirectChannel);
  /**
   * Decides what actions to take with the loggedin user details
   * Based on user types the redirection pages will defer
   * @param {object} authResponse Auth Api response
   */
  const onFetchUserDetailsSuccessful = (authResponse, userDetails, channel) => {
    const { first_login: firstLogin, auth_token } = authResponse;

    if (auth_token) updateTokenToApp(auth_token);

    const reload = isWebView();
    if (firstLogin) {
      return gotoUrl(
        pathWithChannel(paths.CONNECTION_DETAILS, redirectChannel),
        false,
        {},
        reload
      );
    }

    return fetchOrdersAndRedirect(channel, null, userDetails);
  };

  /**
   * Triggers user routing upon successful authentication
   * @param {object} authResponse success response result
   * @param {object} errors API errors only if failed
   */
  const getLoggedinUserDetails = (authResponse, errors, channel) => {
    if (isEmpty(errors)) {
      const header = {
        "X-AUTH": authResponse.auth_token
      };
      const params = loggedInUserDetailsAPIParams();
      dispatch(
        fetchLoggedInUserDetails(
          header,
          params,
          (userDetails, errors) =>
            isEmpty(errors) &&
            onFetchUserDetailsSuccessful(authResponse, userDetails, channel)
        )
      );
    }
  };

  /**
   * When user signup via au first time, user is redirected to the
   * au lost service page, otherwise call getLoggedinUserDetails api
   */
  return (authResponse, errors, channel) => {
    getLoggedinUserDetails(authResponse, errors, channel);
  };
};

export default useAuthorizedUserRedirection;
